var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"75dd21f84ed603b4a70b9231a83297d78cb059e1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["lacinetek-frontend@codekraft-ka"]={id:"75dd21f84ed603b4a70b9231a83297d78cb059e1"};
      